import React from 'react';

const GameResultPopup = ({ resultOnPitcherCard, showResultPopup, resultIsGoodForUser, resultIsXBH, eventWasModified, origPopupText, resultPopupText, managedEventPopup }) => {
    const side = resultOnPitcherCard ? 'on-right' : 'on-left';

    if (showResultPopup) {
        return (
            <div className={`game-result-popup ${side}`}>
                <div className={`result-popup ${resultIsGoodForUser ? 'good' : 'bad'}${resultIsXBH ? ' xbh' : ''}${eventWasModified ? ' modified' : ''}`}>
                    {eventWasModified && (
                        <span className="orig-result">{origPopupText}</span>
                    )}
                    <span className={eventWasModified ? 'final-result' : ''}>{resultPopupText}</span>
                </div>
            </div>
        );
    }

    if (managedEventPopup) {
        return (
            <div className={`game-result-popup ${side}`}>
                <div className={`result-popup managed-event ${managedEventPopup.isGoodForUser ? 'good' : 'bad'}`}>
                    {managedEventPopup.lines.map((line, i) => (
                        <React.Fragment key={i}>
                            {i > 0 && <hr className="managed-event-divider" />}
                            <span className="managed-event-name">{line.name}</span>
                            {line.action && <span className="managed-event-action">{line.action}!</span>}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        );
    }

    return null;
};

export default GameResultPopup;
